import React, { useState, useEffect } from 'react';

const FontSwitcher = ({ onFontChange }) => {
  const [selectedFont, setSelectedFont] = useState('');

  const fonts = [
    { name: 'MeQuran', className: 'font-mequran', displayName: 'Me Quran' },
    { name: 'MeQuran2', className: 'font-mequran2', displayName: 'Me Quran 2' },
    // { name: 'NooreHidayah', className: 'font-nh', displayName: 'Noore Hidayah' },
    { name: 'Othmani', className: 'font-othmani', displayName: 'Othmani' },
    { name: 'Quran', className: 'font-quran', displayName: 'Quran Standard' },
    { name: 'Uthmani', className: 'font-uthmani', displayName: 'Uthmani' },
    { name: 'Scheherazade', className: 'font-scheherazade', displayName: 'Scheherazade' },
    { name: 'Naskh', className: 'font-naskh', displayName: 'Naskh' },
    { name: 'Kitab', className: 'font-kitab', displayName: 'Kitab' },
    { name: 'Kitab Bold', className: 'font-kitab-bold', displayName: 'Kitab Bold' },
    { name: 'Amiri', className: 'font-amiri', displayName: 'Amiri' },
    { name: 'Droid Arabic Kufi', className: 'font-droid-arabic-kufi', displayName: 'Droid Kufi' },
    { name: 'Droid Arabic Naskh', className: 'font-droid-arabic-naskh', displayName: 'Droid Naskh' },
    // { name: 'Thabit', className: 'font-thabit', displayName: 'Thabit' }
  ];

  useEffect(() => {
    // Load saved font preference from localStorage
    const savedFont = localStorage.getItem('preferredFont') || 'font-uthmani';
    setSelectedFont(savedFont);
    if (onFontChange) {
      onFontChange(savedFont);
    }
  }, [onFontChange]);

  const handleFontChange = (fontClass) => {
    setSelectedFont(fontClass);
    localStorage.setItem('preferredFont', fontClass);
    if (onFontChange) {
      onFontChange(fontClass);
    }
  };

  return (
    <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <label htmlFor="font-select">الخط: </label>
      <select
        id="font-select"
        value={selectedFont}
        onChange={(e) => handleFontChange(e.target.value)}
      >
        {fonts.map((font) => (
          <option 
            key={font.name} 
            value={font.className}
          >
            {font.displayName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FontSwitcher;